<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <path
            d="M7.99998 1.73334C8.17166 1.73334 8.3265 1.80544 8.43586 1.92102L11.4242 4.9094C11.6585 5.14371 11.6585 5.52361 11.4242 5.75793C11.1899 5.99224 10.81 5.99224 10.5757 5.75793L8.59997 3.78219V10C8.59997 10.3314 8.33135 10.6 7.99998 10.6C7.66861 10.6 7.39998 10.3314 7.39998 10V3.78219L5.42425 5.75793C5.18994 5.99224 4.81004 5.99224 4.57573 5.75793C4.34141 5.52361 4.34141 5.14371 4.57573 4.9094L7.56409 1.92103C7.67345 1.80545 7.82829 1.73334 7.99998 1.73334Z"
            fill="currentColor"
        />
        <path
            d="M14.1001 9.93339C14.1001 9.60203 13.8315 9.3334 13.5001 9.3334C13.1687 9.3334 12.9001 9.60203 12.9001 9.93339V11.6335C12.9001 12.1765 12.8927 12.3057 12.8642 12.3934C12.7917 12.6167 12.6167 12.7917 12.3934 12.8642C12.3057 12.8927 12.1765 12.9001 11.6335 12.9001H4.36682C3.82378 12.9001 3.69456 12.8927 3.60688 12.8642C3.38362 12.7917 3.20859 12.6167 3.13605 12.3934C3.10756 12.3057 3.10016 12.1765 3.10016 11.6335V9.93341C3.10016 9.60204 2.83153 9.3334 2.50015 9.3334C2.16878 9.3334 1.90015 9.60203 1.90015 9.93341V11.3904C1.90014 11.7436 1.90013 12.0445 1.92031 12.2914C1.94151 12.5508 1.98793 12.8032 2.11087 13.0445C2.29622 13.4083 2.59199 13.7041 2.95576 13.8894C3.19705 14.0124 3.44945 14.0588 3.70889 14.08C3.95583 14.1002 4.2566 14.1001 4.60982 14.1001H11.3904C11.7436 14.1001 12.0444 14.1002 12.2914 14.08C12.5508 14.0588 12.8032 14.0124 13.0445 13.8894C13.4083 13.7041 13.704 13.4083 13.8894 13.0445C14.0123 12.8032 14.0587 12.5508 14.0799 12.2914C14.1001 12.0444 14.1001 11.7437 14.1001 11.3905V9.93339Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'upload-icon',
    props: {
        width: {
            type: [String, Number],
            default: 16,
        },
        height: {
            type: [String, Number],
            default: 16,
        },
        color: {
            type: String,
            default: 'text-content-basic-2',
        },
    },
};
</script>

